const baseOss={
  dev: 'https://gdhy-oss.hebeigaoda.com',
  pro: 'https://gdhy-oss.hebeigaoda.com',
  uat:'https://gdhy-oss.hebeigaoda.com'
}
export default {
  baseUrl: {
    dev: 'http://fch-api.hebeigaoda.com',
    pro: 'https://fch-api.hebeigaoda.com/',
    uat:'http://fch-api.hebeigaoda.com/'
  },
  oss:baseOss[process.env.VUE_APP_ENV]
}
